import {GET_UserRegister,GET_TokenUserRegister} from '../constants/ActionTypes'

const INIT_STATE = {
    
    userRegister: null,
    valuatorCode:null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        // case GET_TokenUserRegister:
        //     return {
        //         userRegister: action.body,
        //         loading :false
                
        //     }
            case GET_UserRegister:
            return {
                userRegister: action.body,
				valuatorCode:action.valcode,
                loading :false
            }
        default:
            return state;
    }
}